import { LexerToken } from '../typings/index';
export const lexerCommonHandler = (
  tokenList: LexerToken[],
  reg: RegExp,
  handle: (rawTokens: string[], t: LexerToken) => LexerToken[]
) => {
  const newTokens: LexerToken[] = [];
  tokenList.forEach(t => {
    const { type, raw } = t;
    if (type === 'text' && reg.test(raw)) {
      // 按照链接的方式对原生字符串进行分割
      const rawTokens = raw.split(reg);
      // 定制的handle逻辑
      newTokens.push(...handle(rawTokens, t));
    } else {
      newTokens.push(t);
    }
  });
  return newTokens;
};

export const resolvePayload = <T>(payload: T, replaceKey: string, ...args: any[]) => {
  if (
    payload &&
    typeof payload === 'object' &&
    typeof payload[replaceKey] !== 'undefined' &&
    payload[replaceKey] !== null
  ) {
    return resolvePayload<T>(payload[replaceKey], replaceKey);
  } else if (typeof payload === 'function') {
    return payload(replaceKey, ...args);
  }
  return payload;
};
